import { render } from "./PanelAdmin.vue?vue&type=template&id=d6d252b0&scoped=true"
import script from "./PanelAdmin.vue?vue&type=script&lang=js"
export * from "./PanelAdmin.vue?vue&type=script&lang=js"

import "./PanelAdmin.vue?vue&type=style&index=0&id=d6d252b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6d252b0"]])

export default __exports__